/**
 * Created by lihanying on 2017/6/22.
 */
import React, { createRef } from 'react'
import { Form, Input, Tooltip, Button, Spin, message } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

const FormItem = Form.Item

class RegistrationForm extends React.Component {
  formRef = createRef()
  constructor(props) {
    super(props)
    this.state = {
      // confirmDirty: false,
      // autoCompleteResult: [],
      loading: false,
    }
  }

  formRef = createRef()

  onFinishFailed = ({ errorFields }) => {
    this.formRef.current.scrollToField(errorFields[0].name)
  }

  onFinish = (values) => {
    let data = {
      account: values.account,
      password: values.password,
      official_person: values.nickname,
      contact_number: values.relationPhone,
      official_person_phone: values.phone,
      club_address: values.residence,
      club_name: values.clubName,
    }
    this.setState({ loading: true })
    this.props.fetchAddClub(data).then((res) => {
      this.setState({ loading: false })
    })
  }

  checkPhone = (rule, value, callback) => {
    if (value && value.length !== 11) {
      callback('您输入的手机号码格式不对')
    } else {
      callback()
    }
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 6,
        },
      },
    }

    return (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }}
      >
        {loading ? (
          <Spin tip="正在提交..." />
        ) : (
          <Form
            ref={this.formRef}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            style={{ width: '500px' }}
          >
            <h3
              style={{
                marginBottom: '2rem',
                fontSize: '20px',
                textAlign: 'center',
              }}
            >
              俱乐部登记表
            </h3>
            <FormItem
              {...formItemLayout}
              name="account"
              rules={[{ required: true, message: '请输入设置的账号!' }]}
              label="账号名称"
              hasFeedback
            >
              <Input />
            </FormItem>
            <FormItem
              {...formItemLayout}
              name="password"
              rules={[{ required: true, message: '请输入设置的密码!' }]}
              label="密码"
              hasFeedback
            >
              <Input type="password" />
            </FormItem>
            <FormItem
              {...formItemLayout}
              name="nickname"
              rules={[{ required: true, message: '请输入俱乐部的负责人!' }]}
              label="负责人"
              hasFeedback
            >
              <Input />
            </FormItem>
            <FormItem
              {...formItemLayout}
              name="relationPhone"
              rules={[{ required: true, message: '请输入联系人的联系电话!' }]}
              label="联系电话"
              hasFeedback
            >
              <Input />
            </FormItem>
            <FormItem
              {...formItemLayout}
              label="手机号码"
              hasFeedback
              name="phone"
              rules={[
                { required: true, message: '请输入负责人手机号码!' },
                { validator: this.checkPhone },
              ]}
            >
              <Input />
            </FormItem>
            <FormItem
              {...formItemLayout}
              name="residence"
              rules={[{ required: true, message: '请输入俱乐部详细地址!' }]}
              label="地址"
              hasFeedback
            >
              <Input />
            </FormItem>

            <FormItem
              {...formItemLayout}
              hasFeedback
              name="clubName"
              rules={[
                {
                  required: true,
                  message: '请输入您的俱乐部名字!',
                  whitespace: true,
                },
              ]}
              label={
                <span>
                  俱乐部&nbsp;
                  <Tooltip title="请输入详细俱乐部名">
                    <QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
            >
              <Input />
            </FormItem>

            <FormItem {...tailFormItemLayout}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100%' }}
              >
                确认
              </Button>
            </FormItem>
          </Form>
        )}
      </div>
    )
  }
}

export default RegistrationForm



// WEBPACK FOOTER //
// ./src/containers/ClubAdd/component/add.js